import {useEffect, useState} from "react"
import {Card, Col, Row} from "react-bootstrap";
import {UsePost, UsePut} from "../../hooks/http";
import {UseMessage} from "../../hooks/UseMessage";
import Form from "./Form";


const Edit = ({id}) => {


    const [errors, setErrors] = useState()
    const [journey, setJourneys] = useState()
    const [audiences, setAudiences] = useState()
    const [isLoading, setIsLoading] = useState(true)


    const GetEntities = async () => {
        const requestJourney = await UsePut(
            `/journeys/get/${id}`,
            {data: {limit: 1, offset: 0, _id: id}}
        )

        const requestAudiences = await UsePut(
            `/audiences/get`,
            {data: {offset: 0}, toArray: true, propLabel: 'name'}
        )

        return {
            journey  : requestJourney?.entities[0],
            audiences: requestAudiences
        }
    }


    useEffect(() => {
        GetEntities().then((response) => {
            setJourneys(response.journey)
            setAudiences(response.audiences)
            setIsLoading(false)
        })
    }, [])


    const handleUpdate = (PostData) => {
        setIsLoading(true)
        UsePost(
            `/journeys/upsert/${id}`,
            {data: PostData}
        ).then((response) => {
            window.setTimeout(() => {
                if (response.code >= 200 && response.code <= 299) {
                    UseMessage('success', 'Journey has been successfully updated')
                    setErrors(undefined)
                } else {
                    setErrors(response.errors)
                }
                setIsLoading(false)
            }, 1500)
        })
    }


    return (
        <>
            <Card>
                <Row>
                    <Col>
                        <div className="max-width-600">
                            <Form journey={journey} audiences={audiences} errors={errors} isReady={!isLoading} onSubmit={handleUpdate}/>
                        </div>
                    </Col>
                </Row>
            </Card>
        </>
    )
}

export default Edit